import classNames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import { PAGE_CLASSES } from '../../routes/pageClasses.constants'
import { UI_ELEMENTS } from '../../store/ui/ui.constants'
import { selectHeaderHeight, selectIsBackButtonDisplayed } from '../../store/ui/ui.selectors'
import { selectIsUserAccountEnabled } from '../../store/userAccount/userAccount.selectors'
import { isPE } from '../Device'
import UserButton from '../UserAccount/UserButton'
import MenuCategoriesPE from '../menu/MenuCategoriesPE'
import useComputedHeaderHeight from '../ui/useHeaderHeight'
import useUIDisplay from '../ui/useUIDisplay'
import DesktopPreHeader from './DesktopPreHeader'
import s from './Header.less'
import SubHeader from './SubHeader'

export const Header = ({ subHeader, headerButton, children, menuCategoriesPE , transparent }) => {
  const { isUIDisplayed: suggestDisplayed } = useUIDisplay(UI_ELEMENTS.SUGGEST)
  const { isUIDisplayed: searchDialogDisplayed } = useUIDisplay(UI_ELEMENTS.SEARCH_DIALOG)
  const backButtonDisplayed = useSelector(selectIsBackButtonDisplayed)
  const headerHeight = useSelector(selectHeaderHeight)

  const userAccountEnabled = useSelector(selectIsUserAccountEnabled)
  const shouldDisplayUserAccount = isPE() && userAccountEnabled && !backButtonDisplayed

  const shouldDisplayMenuCategoriesPE = menuCategoriesPE && !suggestDisplayed && !searchDialogDisplayed

  const computedHeaderHeight = useComputedHeaderHeight(menuCategoriesPE, subHeader)

  return (
    <header className={s.root} style={{ height: computedHeaderHeight }}>
      <div
        className={classNames(
          s.container,
          backButtonDisplayed && PAGE_CLASSES.withBackButton,
          !suggestDisplayed && headerButton && PAGE_CLASSES.withHeaderButton,
          shouldDisplayUserAccount && PAGE_CLASSES.withUserAccountButton,
          transparent && s.transparent
        )}
        style={{
          height: headerHeight
        }}
      >
        {shouldDisplayUserAccount && (
          <div className={s.userAccountPE}>
            <UserButton />
          </div>
        )}
        {children}
        {!suggestDisplayed && headerButton}
      </div>
      {subHeader && <SubHeader key="SubHeader">{subHeader}</SubHeader>}
      <DesktopPreHeader key={'desktop-pre-header'} />
      {shouldDisplayMenuCategoriesPE && (
        <div className={s.menuCategoriesPE}>
          <MenuCategoriesPE />
        </div>
      )}
    </header>
  )
}

export default Header
